import React from 'react';
import { useContext, useEffect, useState } from 'react';
import { block, unblock } from '../../helpers/loading';
import { FichaContext } from '../../context/FichaContext';
import { axiosPublic } from '../../helpers/axios';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
var moment = require('moment');

export const valida = (param) => {
	const minValue = param.length > 2;
	const soloLetras = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/g.test(param);
	let obj = ['', false];

	if (!soloLetras) {
		obj = ['Solo incluir letras.', true];
	}

	if (!minValue) {
		obj = ['', true];
	}

	return obj;
};

export const validaNum = (param) => {
	const solonum = /^[0-9]+$/.test(param);
	let obj = ['', false];

	if ((!solonum || param < 0) && param !== '') {
		obj = ['Solo incluir números (enteros).', true];
	}
	return obj;
};

export const validaCelular = (param) => {
	const solonum = /^(501|502|503|504|505|506|507)?\d{8}$/.test(param);
	let obj = ['', false];

	if ((!solonum || param < 0) && param !== '') {
		obj = ['Formato inválido.', true];
	}
	return obj;
};

export const validaCorreo = (param) => {
	const valCorreo =
		/^(([^<>()\],;:\s@]+(\.[^<>()\],;:\s@]+)*)|(.+))@(([^<>()[\],;:\s@]+\.)+[^<>()[\],;:\s@]{2,})$/.test(param);
	let obj = ['', false];
	if (!valCorreo && param !== '') {
		obj = ['Formato incorrecto.', true];
	}
	return obj;
};

export const validaIdentidad = (param) => {
	const valCorreo =
		/^(0(10[1-8]|2(0[1-9]|10)|3(0[1-9]|1[0-9]|2[01])|4(0[1-9]|1[0-9]|2[0-3])|5(0[1-9]|1[0-2])|6(0[1-9]|1[0-6])|7(0[1-9]|1[0-9])|8(0[1-9]|1[0-9]|2[0-8])|90[1-6])|1(0(0[1-9]|1[0-7])|10[1-4]|2(0[1-9]|1[0-9])|3(0[1-9]|1[0-9]|2[0-8])|4(0[1-9]|1[0-6])|5(0[1-9]|1[0-9]|2[0-3])|6(0[1-9]|1[0-9]|2[0-8])|70[1-9]|8(0[1-9]|1[01])))(19[5-9][0-9]|20(0[0-9]|1[0-9]))\d{5}$/.test(
			param
		);
	let obj = ['', false];
	if (!valCorreo && param !== '') {
		obj = ['Formato incorrecto.', true];
	}
	return obj;
};

export const PrimeraPagina = () => {
	const [hidden, setHidden] = useState(true);
	const [etnias, setEtnias] = useState([]);
	const [Ecivil, setEcivil] = useState([]);
	const [Limitacion, setLimita] = useState([]);
	const { data, setData } = useContext(FichaContext);
	const { primera } = data;
	const valfecha = moment().subtract(15, 'y');

	const handleFechanaci = (Value) => {
		setData({
			...data,
			primera: {
				...primera,
				fechanaci: Value,
			},
		});
	};
	const {
		Pnombre,
		Papellido,
		identidad,
		correo,
		confcorreo,
		fechanaci,
		edad,
		tcasa,
		tcelular,
		sexo,
		trabaja,
		nacionalidad,
		ecivil,
		limitacion,
		etnia,
		Snombre,
		Sapellido,
		AGraduacion,
		otraLimita,
	} = primera;

	const handleInputChange = ({ target }) => {
		setData({
			...data,
			primera: {
				...primera,
				[target.name]: target.value,
			},
		});
	};

	useEffect(() => {
		block();
		axiosPublic('etnias')
			.then((response) => setEtnias(response.data.etnias))
			.catch((error) => console.log(error));

		axiosPublic('estado_civil')
			.then((response) => setEcivil(response.data.estado_civil))
			.catch((error) => console.log(error));

		axiosPublic('limitaciones')
			.then((response) => setLimita(response.data.limitacion))
			.catch((error) => console.log(error));
		unblock();
	}, []);

	useEffect(() => {
		if (limitacion === '11') {
			setHidden(false);
		} else {
			setHidden(true);
			setData({
				...data,
				primera: {
					...primera,
					otraLimita: '',
				},
			});
		}
	}, [limitacion, setHidden]);

	const otraChange = ({ target }) => {
		setData({
			...data,
			primera: {
				...primera,
				[target.name]: target.value,
			},
		});
	};
	return (
		<div className="cuerpo">
			<legend className="titulo card-header">DATOS GENERALES</legend>
			<div className="formu">
				<div>
					<div className="txtfloat form-floating">
						<input
							className="txt form-control"
							type="text"
							minLength={3}
							maxLength={15}
							name="Pnombre"
							value={Pnombre}
							onChange={handleInputChange}
							placeholder="escribir"
							required
							autoFocus
						/>
						<label className="lb">Primer Nombre:</label>
					</div>
					<i className="val">{valida(Pnombre)}</i>
				</div>

				<div>
					<div className="txtfloat form-floating">
						<input
							className="txt form-control"
							minLength={3}
							maxLength={15}
							name="Snombre"
							value={Snombre}
							onChange={handleInputChange}
							placeholder="escribir"
						></input>
						<label className="lb">Segundo Nombre:</label>
					</div>
					<i className="val">{valida(Snombre)}</i>
				</div>
			</div>

			<div className="formu">
				<div>
					<div className=" txtfloat form-floating">
						<input
							className="txt form-control"
							minLength={3}
							maxLength={15}
							name="Papellido"
							placeholder="escribir"
							value={Papellido}
							onChange={handleInputChange}
						></input>
						<label className="lb">Primer Apellido:</label>
					</div>
					<i className="val">{valida(Papellido)}</i>
				</div>

				<div>
					<div className=" txtfloat form-floating">
						<input
							className="txt form-control"
							minLength={3}
							maxLength={15}
							name="Sapellido"
							placeholder="escribir"
							value={Sapellido}
							onChange={handleInputChange}
						></input>
						<label className="lb">Segundo Apellido:</label>
					</div>
					<i className="val">{valida(Sapellido)}</i>
				</div>
			</div>

			<div className="formu">
				<div>
					<div className="txtfloat form-floating">
						<input
							className="txt form-control"
							type="text"
							name="identidad"
							maxLength={15}
							placeholder="escribir"
							value={identidad}
							onChange={handleInputChange}
						></input>
						<label className="lb">ID o pasaporte (sin guiones):</label>
					</div>
					{nacionalidad === '99' && <i className="val">{validaIdentidad(identidad)}&nbsp;</i>}
					{nacionalidad === '99' && <i className="val">{validaNum(identidad)}</i>}
					{identidad.length < 8 && identidad !== '' && <i className="val">Minimo 8 dígitos</i>}
				</div>

				<div>
					<div className="txtfloat form-floating">
						<input
							className="txt form-control"
							maxLength={2}
							min="15"
							type="number"
							name="edad"
							placeholder="escribir"
							value={edad}
							pattern="[0-9]+"
							onChange={handleInputChange}
						/>
						<label className="lb">Edad:</label>
					</div>
					<i className="val">{validaNum(edad)}</i>
					{(edad.length > 2 || (edad < 15 && edad !== '') || (edad.length < 2 && edad !== '')) && (
						<i className="val">Máximo 2 dígitos (mayor a 15 años)</i>
					)}
				</div>
			</div>

			<div className="formu">
				<div className="radios">
					<label className="lb">Sexo :&nbsp;&nbsp;</label>
					<div>
						<label className="form-check-label">M&nbsp;</label>
						<input
							className="form-check-input"
							type="radio"
							name="sexo"
							id="rdsexo1"
							value={'0'}
							checked={sexo === '0'}
							onChange={handleInputChange}
						/>

						<label className="form-check-label">&nbsp;&nbsp;F&nbsp;</label>
						<input
							className="form-check-input"
							type="radio"
							name="sexo"
							id="rdsexo2"
							value={'1'}
							checked={sexo === '1'}
							onChange={handleInputChange}
						/>
					</div>
				</div>

				<div className="txtfloat form-floating">
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<DesktopDatePicker
							className="txtfloat bg-white"
							disableHighlightToday
							openTo="year"
							value={fechanaci}
							label="Fecha de nacimiento:"
							inputFormat="DD/MM/yyyy"
							maxDate={valfecha}
							minDate={moment().subtract(70, 'y')}
							onChange={handleFechanaci}
							renderInput={(params) => <TextField name="fechanaci" {...params} />}
						/>
					</LocalizationProvider>
					{/* <input className="txt form-control" type="date" name="fechanaci" min="1930-01-01" lang="en" placeholder="escribir" value={fechanaci} onChange={handleInputChange}></input>            */}
					{/*  <label className="lb"> </label> */}
					{moment(fechanaci).isAfter(valfecha) && (
						<i className="val">Ingrese fecha anterior al {moment(valfecha).year()}</i>
					)}
					{moment(fechanaci).isBefore(moment().subtract(70, 'y')) && (
						<i className="val">Formato incorrecto</i>
					)}
				</div>
			</div>

			<div className="formu">
				<div className="selection form-floating">
					<select
						className="txtfloat form-select"
						id="floatingSelect"
						name="ecivil"
						value={ecivil}
						onChange={handleInputChange}
						required
					>
						<option className="selec" disabled value={''}>
							Seleccionar...
						</option>
						{Ecivil.map((ecivil) => (
							<option key={ecivil.id} value={ecivil.id}>
								{ecivil.etiqueta}
							</option>
						))}
					</select>
					<label className="lb">Estado Civil:</label>
				</div>

				<div className="selection form-floating">
					<select
						className="txtfloat form-select"
						id="floatingSelect"
						name="etnia"
						value={etnia}
						onChange={handleInputChange}
						required
					>
						<option disabled value={''}>
							Seleccionar...
						</option>
						{etnias.map((etnias) => (
							<option key={etnias.id} value={etnias.id}>
								{etnias.etiqueta}
							</option>
						))}
					</select>
					<label className="lb">Grupo poblacional:</label>
				</div>
			</div>

			<div className="formu">
				<div>
					<div className=" txtfloat form-floating">
						<input
							className="txt form-control"
							type="text"
							name="tcasa"
							maxLength={12}
							placeholder="escribir"
							value={tcasa}
							onChange={handleInputChange}
						></input>
						<label className="lb">Teléfono Casa (solo números):</label>
					</div>
					<i className="val">{validaNum(tcasa)}</i>
					{(tcasa.length > 11 || tcasa.length < 8) && tcasa !== '' && (
						<i className="val">&nbsp;&nbsp;Mínimo 8 dígitos, Máximo 11 </i>
					)}
				</div>
				<div>
					<div className=" txtfloat form-floating">
						<input
							className="txt form-control"
							type="text"
							name="tcelular"
							maxLength={11}
							placeholder="telefono"
							value={tcelular}
							onChange={handleInputChange}
						></input>
						<label className="lb">Teléfono Celular (solo números):</label>
					</div>
					<i className="val">{validaCelular(tcelular)}</i>
					<i className="val">{validaNum(tcelular)}</i>
					{(tcelular.length > 11 || tcelular.length < 8) && tcelular !== '' && (
						<i className="val">&nbsp;&nbsp;Mínimo 8 dígitos, Máximo 11 </i>
					)}
				</div>
			</div>
			<div className="formu">
				<div>
					<div className="txtfloat form-floating">
						<input
							type="email"
							className="txt form-control"
							name="correo"
							placeholder="escribir"
							value={correo}
							onChange={handleInputChange}
							required
						></input>
						<label className="lb">Correo:</label>
					</div>
					<i className="val">{validaCorreo(correo)}</i>
				</div>
				<div>
					<div className="txtfloat form-floating">
						<input
							type="email"
							className="txt form-control"
							id="floatingInput"
							name="confcorreo"
							placeholder="escribir"
							value={confcorreo}
							onChange={handleInputChange}
						></input>
						<label className="lb">Confirmar Correo:</label>
					</div>
					{correo !== confcorreo && confcorreo !== '' && <i className="val">El correo no coincide</i>}
				</div>
			</div>
			<div className="formu">
				<div className="selection form-floating">
					<select
						className="txtfloat form-select"
						id="floatingSelect"
						name="nacionalidad"
						value={nacionalidad}
						onChange={handleInputChange}
						required
					>
						<option disabled value={''}>
							Seleccionar...
						</option>
						<option value="99">Honduras</option>
						<option value="64">El Salvador</option>
						<option value="54">Costa Rica</option>
						<option value="91">Guatemala</option>
						<option value="161">Nicaragua</option>
						<option value="174">Panamá</option>
						<option value="24">Belice</option>
						<option value="0">Otro país</option>
					</select>
					<label className="lb">País de nacimiento:</label>
				</div>
				<div className="radios">
					<label className="lb">Trabaja : &nbsp;&nbsp;</label>
					<div>
						<label className="form-check-label">Sí&nbsp;</label>
						<input
							className="form-check-input"
							type="radio"
							name="trabaja"
							id="rdtrabajo1"
							value={true}
							checked={trabaja === 'true'}
							onChange={handleInputChange}
						/>

						<label className="form-check-label">&nbsp;&nbsp;No&nbsp;</label>
						<input
							className="form-check-input"
							type="radio"
							name="trabaja"
							id="rdtrabajo2"
							value={false}
							checked={trabaja === 'false'}
							onChange={handleInputChange}
						/>
					</div>
				</div>
			</div>
			<div className="formu">
				<div className="txtfloat form-floating">
					<input
						className="txt form-control"
						maxLength={4}
						min="1960"
						type="number"
						name="AGraduacion"
						placeholder="escribir"
						value={AGraduacion}
						pattern="[0-9]+"
						onChange={handleInputChange}
					/>
					<label className="lb">Año de graduación:</label>
				</div>

				<div className="selection form-floating">
					<select
						className="txtfloat form-select"
						id="floatingSelect"
						name="limitacion"
						value={limitacion}
						onChange={handleInputChange}
						required
					>
						<option disabled value={''}>
							Seleccionar...
						</option>
						{Limitacion.map((limitacion) => (
							<option key={limitacion.id} value={limitacion.id}>
								{limitacion.etiqueta}
							</option>
						))}
					</select>
					<label className="lb">¿Presenta alguna condición de vida?</label>
				</div>

				<div className=" txtfloat3 form-floating">
					<input
						className="txtfloat3 form-control"
						type="text"
						hidden={hidden}
						name="otraLimita"
						value={otraLimita}
						placeholder="escribir"
						onChange={otraChange}
					></input>
					<label className="lb" hidden={hidden}>
						Especifique ¿cuál?&nbsp;:
					</label>
				</div>
			</div>
		</div>
	);
};
